import isUrl from 'is-url';

import { LESTE_PREDEFINED_APP_ID, LESTE_EMBEDDED, LESTE_MSISDN } from '../../../../../../constants/storage';

export const handleOpenEditor = (searchParams: string, editorAddress: string, msisdn: string) => {
  const openInTheSameDomain = () => {
    const params = new URLSearchParams(searchParams);
    const appId = params.get('appId') || '';

    if (appId) {
      sessionStorage.setItem(LESTE_PREDEFINED_APP_ID, appId);
    } else {
      sessionStorage.removeItem(LESTE_PREDEFINED_APP_ID);
    }
    sessionStorage.setItem(LESTE_EMBEDDED, 'true');
    sessionStorage.setItem(LESTE_MSISDN, msisdn);

    return editorAddress;
  };

  const openInDifferentDomain = () => {
    const openEditorWithPredefinedApplication = `${editorAddress}${searchParams}&embedded=true?msisdn=${msisdn}`;
    const openEditorWithAllApplications = `${editorAddress}?embedded=true?msisdn=${msisdn}`;
    return searchParams ? openEditorWithPredefinedApplication : openEditorWithAllApplications;
  };

  const differentDomain = isUrl(editorAddress) && editorAddress.includes(document.location.host);

  if (differentDomain) {
    return openInDifferentDomain();
  }
  return openInTheSameDomain();
};
